(function () {
  function getParam(param) {
    const url = new URL(window.location.href);
    return url.searchParams.get(param);
  }

  const ref = getParam('ref') || getParam('aff'); // ikisini de destekle
  const savedRid = localStorage.getItem('referral_rid');

  // cart'a attribute yazan helper
  async function writeRidToCart(rid) {
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { referral_rid: rid }
        })
      });
    } catch (e) {
      console.error('[affiliate] cart update failed', e);
    }
  }

  // 1) Eğer URL'de ref varsa track et
  async function track(refCode) {
    const payload = {
      action: 'trackReferral',
      ref: refCode,
      landing_url: window.location.href
      // istersen shop_domain de gönder: shopify.liquid ile basılabilir
      // shop_domain: "{{ shop.permanent_domain }}"
    };

    const res = await sendDataToProxy(payload);
    if (res && res.ok && res.rid) {
      localStorage.setItem('referral_rid', res.rid);
      localStorage.setItem('referral_ref', refCode);
      localStorage.setItem('referral_expires_at', res.expires_at || '');
      await writeRidToCart(res.rid);
      return true;
    }
    return false;
  }

  // 2) Akış
  (async () => {
    if (ref) {
      await track(ref);
    } else if (savedRid) {
      // ref yok ama önceki rid varsa cart'a tekrar bas
      await writeRidToCart(savedRid);
    }
  })();

})();
